import DataTable from '@visa/vds/data-table';
import ScreenReader from '@visa/vds/screen-reader';
import Tbody from '@visa/vds/tbody';
import Td from '@visa/vds/td';
import Th from '@visa/vds/th';
import Thead from '@visa/vds/thead';
import Tr from '@visa/vds/tr';
import Typography from '@visa/vds/typography';
import { DateHelper } from '_helpers/DateHelper';
import React from 'react';
import { AlignPadRight, AlignRight, applyFeeWaiverToProductFee, GetUSDCurrencyString } from '../FeeWaiver/FeeWaiverLogic';

const VSTSOrderSummaryTable = (props) => {
    return (
        <>
            <DataTable className="table-subscription" size='compact'>
                <ScreenReader tag="caption">Order Summary Table</ScreenReader>
                <Thead >
                    <Tr >
                        <Th scope="col">Product</Th>
                        <Th style = {AlignRight} scope="col">Amount</Th>
                        <Th style = {AlignPadRight} scope="col">Remarks</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {props.orderSummaryProductsList && props.orderSummaryProductsList.map((product,key)=>(
                        <>
                            <Tr key={key}>
                                <Td>
                                    <Typography tag="h3" variant="headline"><b id="VSTS-suite-name">{product.productName}</b></Typography>
                                    <Typography tag="h4" variant="headline--alt"><b id="VSTS-subscription type">{product.productInfoName}</b></Typography>
                                    <Typography className="vss-field-label" id="VSTS-start-date-text"><b>Start Date: </b>{product.startDate && DateHelper.ToFormattedDate(product.startDate)}</Typography>
                                    <Typography className="vss-field-label" id="VSTS-end-date-text"><b>End Date: </b>{product.endDate && DateHelper.ToFormattedDate(product.endDate)}</Typography>
                                </Td>
                                <Td style={AlignRight}>
                                    <Typography id="VSTS-price">{GetUSDCurrencyString(product.fee)}</Typography>
                                </Td>
                                <Td style = {AlignRight}></Td>
                            </Tr>
                            {props.selectedFeeWaiver && props.selectedFeeWaiver.productId === product.productId &&
                            <Tr>
                                <Td>
                                    <Typography 
                                        className="vss-fee-waiver-field-label" 
                                        style={{ margin: 0 }}>
                                            <b>Fee Waiver or Fee Discount Applied: </b>{props.selectedFeeWaiver.description}
                                    </Typography>
                                </Td>
                                <Td style={AlignRight}>
                                    <Typography 
                                        className="order-review-table-fee-waiver-value">
                                        {GetUSDCurrencyString(applyFeeWaiverToProductFee(product, props.selectedFeeWaiver))}
                                    </Typography>
                                </Td>
                                <Td style = {AlignRight}></Td>
                            </Tr>
                            }
                        </>
                    ))}
                    <Tr className="total-tr">
                        <Td><Typography className="total-header" tag="h4" variant="headline--alt"><b>Total</b></Typography></Td>
                        {/* <Td><b>{GetUSDCurrencyString(props.total)}</b></Td> */}
                        <Td style={AlignRight}><b>{GetUSDCurrencyString(props.total)}</b></Td>
                        <Td style = {AlignRight}></Td>
                    </Tr>
                </Tbody>
            </DataTable>
        </>
    )
}

export default VSTSOrderSummaryTable